import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgxMaskPipe } from 'ngx-mask';

@Directive({
  selector: '[luiDatepickerMask]',
  standalone: true,
})
export class DatepickerMaskDirective {
  inputEl!: HTMLInputElement;
  @Input('luiDatepickerMask') mask: string = '00/00/0000';

  @HostListener('keyup') onChange() {
    this.inputEl.value = this.pipe.transform(this.inputEl.value, this.mask);
  }

  constructor(element: ElementRef, private pipe: NgxMaskPipe) {
    if (!(element.nativeElement && 'value' in element.nativeElement)) {
      throw new Error(
        'The DatepickerMaskDirective directove can only be applied to an input element'
      );
    }
    this.inputEl = element.nativeElement;
  }
}
